import { getToken } from "./user-service";
import axios from "axios";
import moment from 'moment';

const takeOutDoc = (dict) => {
  if (typeof dict === "string") return dict
  return dict?.map((e) => e.doc);
}

export const getBookingsReport = async (params, signal) => {
  const token = await getToken();
  const new_url =
    "api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    params.start +
    "&end=" +
    params.end +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip +
    "&type=" + params.type +
    "&name=" +
    params.search +
    "&carrierCode=" +
    (params.carrierCode ? params.carrierCode : "") +
    `${params.csv ? "&csv=" + params.csv : ""}` +
    `${params.source ? "&source=" + params.source : ""}` +
    `${params.forecast ? "&forecast=" + params.forecast : ""}`;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(new_url, {
        signal: signal.signal,
        headers: { "Firebase-UID": token },
      });

      if (params.csv || params.forecast) {
        resolve(response.data);
      }

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      let bookings = await takeOutDoc(response.data);
      resolve(bookings);

    } catch (e) {
      console.log("error getting bookings:", e);

      reject(new Error("error getting bookings"));
    }
  });
};

export const getForecastReport = async (params, signal) => {
  const token = await getToken();

  const startDate = moment(new Date(params.start)).format().split("T")[0]
  const endDate = moment(new Date(params.end)).format().split("T")[0]

  const new_url =
    "api/v1/bookings/bookings/" +
    params.iata +
    "?start=" +
    startDate +
    "&end=" +
    endDate +
    "&limit=" +
    params.limit +
    "&skip=" +
    params.skip +
    "&type=" + params.type +
    "&name=" +
    params.search +
    "&carrierCode=" +
    (params.carrierCode ? params.carrierCode : "") +
    `${params.csv ? "&csv=" + params.csv : ""}` +
    `${params.source ? "&source=" + params.source : ""}` +
    `${params.forecast ? "&forecast=" + params.forecast : ""}`;

  return new Promise(async (resolve, reject) => {
    try {

      const response = await axios.get(new_url, {
        signal: signal.signal,
        headers: { "Firebase-UID": token },
      });

      let result = {
        bookings: response.data,
        startDate: startDate,
        endDate: endDate,
      }
      if (params.csv || params.forecast) {
        resolve(result);
      }

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }

      let bookings = await takeOutDoc(response.data);
      resolve({ bookings: bookings, startDate: startDate, endDate: endDate });

    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};

// used for getting all counts for the entire month for the calendar
export const getBookingsCount = async (params) => {
  const token = await getToken();

  const url =
    "/api/v1/bookings/bookingAnalytics/" +
    params.iata +
    "/counts" +
    "?date=" +
    params.date +
    `&type=${params.type || "all"}` +
    `&range=${params.range || "month"}` +
    `&byType=${params.byType || "none"}` +
    `&airline=${params.airline || ""}` +
    `&endDate=${params.endDate || ""}` +
    `&byHour=${params.byHour || ""}` +
    `&source=${params.source || "all"}` +
    `&byFlight=${params.byFlight || ""}` +
    `&forecast=${params.forecast || ""}` +
    `&reduce=${params.reduce}` +
    (params.breakdownTable ? `&breakdownTable=${params.breakdownTable}` : "") +
    `&noshows=${params.noShows == undefined ? "false" : params.noShows || "false"}`;

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json.data);
    } catch (e) {
      reject(new Error("error getting bookings"));
    }
  });
};


export const getSLAReport = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();

      const url =
        "/api/v1/timeline/timeline/" +
        params.iata +
        "/SLAReport" +
        "?start=" +
        params.startDate +
        `&end=${params.endDate}`;
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json.data);

    } catch (error) {
      console.error("Error getting task list:", error);
      reject(error);
    }
  });
};

export const getAirlinePerformanceReport = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const url =
        `/api/v1/timeline/timeline/${params.iata}/AirlinePerformanceReport?start=${params.startDate}&end=${params.endDate}&source=${params.source}&airline=${params.airline}&airport=${params.airport}`;
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });
      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(json.data);
    } catch (error) {
      console.error("Error getting task list:", error);
      reject(error);
    }
  });
};

export const getEmployeeConvReport = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await axios.get(`/api/v1/timeline/messages/getEmployeeConvReport/${params.iata}?employeeId=${params.employeeId}&startDate=${params.startDate}&endDate=${params.endDate}`, {
        headers: { "Firebase-UID": token },
      });
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(response.data);
    } catch (error) {
      console.error("Error getting employee conversation messages:", error);
      reject(error);
    }
  });
};


export const getFlightsListReport = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await axios.get(`/api/v1/timeline/messages/getFlightsListReport/${params.iata}?startDate=${params.startDate}&endDate=${params.endDate}`, {
        headers: { "Firebase-UID": token },
      });
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(response.data);
    } catch (error) {
      console.error("Error getting flights list report:", error);
      reject(error);
    }
  });
};

export const getFlightMessagesByConversationId = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await axios.get(`/api/v1/timeline/messages/getFlightMessagesByConversationId/${params.conversationId}`, {
        headers: { "Firebase-UID": token },
      });
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad booking details");
      }
      resolve(response.data);
    } catch (error) {
      console.error("Error getting flight messages by conversation id:", error);
      reject(error);
    }
  });
};

export const getBreaksReport = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await axios.get(
        `/api/v1/cpu/sla-reports/breaksReport?iata=${params.iata}&startDate=${params.startDate}&endDate=${params.endDate}`,
        { headers: { "Firebase-UID": token } }
      );
      if (response.status >= 400 && response.status < 600) {
        throw new Error('Bad breaks report response');
      }
      resolve(response.data);
    } catch (error) {
      console.error('Error getting breaks report:', error);
      reject(error);
    }
  });
};

export const getGateChangesReport = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await axios.get(
        `/api/v1/cpu/sla-reports/gateChangesReport?iata=${params.iata}&date=${params.date}`,
        { headers: { "Firebase-UID": token } }
      );
      if (response.status >= 400 && response.status < 600) {
        throw new Error('Bad gate changes report response');
      }
      resolve(response.data);
    } catch (error) {
      console.error('Error getting gate changes report:', error);
      reject(error);
    }
  });
};

export const getEquipmentReport = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const iataParam = params.iata ? `&iata=${params.iata}` : '';
      const response = await axios.get(
        `/api/v1/mobileusers/user/equipment-report?startDate=${params.startDate}&endDate=${params.endDate}${iataParam}`,
        { headers: { "Firebase-UID": token } }
      );
      if (response.status >= 400 && response.status < 600) {
        throw new Error('Bad equipment report response');
      }
      resolve(response.data);
    } catch (error) {
      console.error('Error getting equipment report:', error);
      reject(error);
    }
  });
};

export const getThirdStateFlightsReport = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const response = await axios.get(
        `/api/v1/cpu/sla-reports/thirdStateFlights?iata=${params.iata}&date=${params.date}`,
        { headers: { "Firebase-UID": token } }
      );
      if (response.status >= 400 && response.status < 600) {
        throw new Error('Bad third state flights report response');
      }
      resolve(response.data);
    } catch (error) {
      console.error('Error getting third state flights report:', error);
      reject(error);
    }
  });
};

export const getSunflowerLanyardReport = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getToken();
      const query = new URLSearchParams();
      if (params?.startDate) query.append("startDate", params.startDate);
      if (params?.endDate) query.append("endDate", params.endDate);
      if (params?.airport) query.append("airport", params.airport);
      const response = await axios.get(
        `/api/v1/marketplace/transactions/sunflowerReport?${query.toString()}`,
        { headers: { "Firebase-UID": token } }
      );
      if (response.status >= 400 && response.status < 600) {
        throw new Error('Bad sunflower lanyard report response');
      }
      resolve(response.data);
    } catch (error) {
      console.error('Error getting sunflower lanyard report:', error);
      reject(error);
    }
  });
};

export const getFlightsScheduleReport = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {

      const token = await getToken();
      const typeParam = params?.type && params?.type !== 'all' ? `&type=${params.type}` : '';
      const response = await axios.get(`/api/v1/flights/schedules/flightsReport/${params?.iata}?startDate=${params?.startDate}&endDate=${params?.endDate}${typeParam}`, {
        headers: { "Firebase-UID": token },
      });

      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad flights schedule report");
      }
      resolve(response.data);

    } catch (error) {
      console.error("Error getting flights schedule report:", error);
      reject(error);
    }
  });
};